import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import EnforcementUserDetailViewModel from "viewModels/enforcement/enforcementUsers/enforcementUserDetailViewModel";
import EditableDetailView from "../../common/editableDetailView";
import EnforcementUserForm from "./enforcementUserForm";

const EnforcementUserDetailView: ViewComponent<EnforcementUserDetailViewModel> = observer(({ vm }) => {
  return <EditableDetailView vm={vm} form={<EnforcementUserForm vm={vm} />} />;
});

registerView(EnforcementUserDetailView, EnforcementUserDetailViewModel);
